import React from "react";

const DashboardSummaryStrip = ({ items, className = "", style = {}, bordered = true }) => {
  if (!items || items.length === 0) return null;

  return (
    <div
      className={`dashboard-summary-strip mb-4 ${className}`}
      style={{
        ...(bordered
          ? {
              borderTop: "1px dashed var(--theme-border, #EBEBEB)",
              borderBottom: "1px dashed var(--theme-border, #EBEBEB)",
            }
          : {}),
        ...style,
      }}
    >
      <div className="p-3 flex flex-wrap gap-3">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <div className="flex-1 min-w-0">
              {item.label && (
                <span
                  className="text-xs font-medium uppercase mb-1 block"
                  style={{ color: "var(--theme-text-muted)" }}
                >
                  {item.label}
                </span>
              )}
              <div
                className="text-2xl font-medium"
                style={{ color: item.valueColor || "var(--theme-text)" }}
              >
                {item.value}
              </div>
              {item.helper && (
                <span
                  className="text-xs"
                  style={{ color: item.helperColor || "var(--theme-text-muted)" }}
                >
                  {item.helper}
                </span>
              )}
            </div>
            {index < items.length - 1 && (
              <div
                style={{
                  width: "1px",
                  height: "3rem",
                  background: "var(--theme-border, #e0e0e0)",
                }}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default DashboardSummaryStrip;

